import React, { Component } from 'react';
import TeacketContext from './TeacketContext';

var currentTicketConversationGlobal = null;
export default class GlobalProvider extends Component {
  state = {
    // SERVICES
    servicesForTenant: null,
    // CURRENT TICKET
    currentTicket: null,
    currentTicketConversation: null,
    currentTicketIsMasterTenant: null,
    currentTicketMembers: null,
    currentTicketReadOnly: true,
    currentTicketHistory: null,
    currentTicketCustomFields: null,
    currentTicketS3FilesList: null,
    activeViewers: [],
    // USER TICKET LIST
    userTicketList: null,
    userTicketListRefresh: false,
    // OTHERS
    ticketList: null,
    dashboardUser: null,
  };

  render() {
    return (
      <TeacketContext.Provider
        value={{
          ...this.state,

          // ### SERVICES ###
          setServicesForTenant: (servicesForTenant) => this.setState({ servicesForTenant }),

          // ### CURRENT TICKET ###
          setCurrentTicket: (ticket, isMaster) => this.setState({ currentTicket: ticket, currentTicketIsMasterTenant: isMaster }),
          updateCurrentTicket: (updates) => {
            const currentTicket = { ...this.state.currentTicket, ...updates };
            this.setState({ currentTicket });
          },
          setCurrentTicketConversation: (conversation) => {
            currentTicketConversationGlobal = conversation;
            this.setState({
              currentTicketConversation: conversation,
            });
          },
          addCurrentTicketConversationMessage: (message) => {
            let c = [...currentTicketConversationGlobal].filter((m) => !m.isPosting);
            c.push(message);
            c = c.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
            currentTicketConversationGlobal = c;
            this.setState({ currentTicketConversation: c });
          },
          setCurrentTicketMembers: (members) => this.setState({ currentTicketMembers: members }),
          setCurrentTicketReadOnly: (readOnly) => this.setState({ currentTicketReadOnly: readOnly }),
          setCurrentTicketHistory: (history) => this.setState({ currentTicketHistory: history }),
          setCurrentTicketCustomFields: (customFields) => this.setState({ currentTicketCustomFields: customFields }),
          setCurrentTicketS3FilesList: (currentTicketS3FilesList) => this.setState({ currentTicketS3FilesList }),
          getCurrentTicketService: () => {
            return this.state.servicesForTenant.find((s) => s.id === this.state.currentTicket.service_id);
          },
          setActiveViewers: (activeViewers) => this.setState({ activeViewers }),
          resetCurrentTicket: () => {
            this.setState({
              currentTicket: null,
              currentTicketConversation: null,
              currentTicketIsMasterTenant: null,
              currentTicketMembers: null,
              currentTicketReadOnly: true,
              currentTicketHistory: null,
              currentTicketS3FilesList: null,
              currentTicketCustomFields: null,
            });
          },

          // ### USER TICKET LIST ###
          setUserTicketList: (userTicketList) => this.setState({ userTicketList }),
          setUserTicketListRefresh: (userTicketListRefresh) => this.setState({ userTicketListRefresh }),

          // ### OTHERS ###
          setTicketList: (ticketList) => this.setState({ ticketList }),
          setDashboardUser: (dashboardUser) => this.setState({ dashboardUser }),
        }}
      >
        {/* eslint-disable-next-line react/prop-types */}
        {this.props.children}
      </TeacketContext.Provider>
    );
  }
}
